import { colors, gradients } from '@airwallex/global';
var accountGroupNavTheme = {
  background: colors.greys[10],
  item: {
    color: colors.greys[80],
    hover: {
      color: colors.greys[60]
    },
    selected: {
      gradient: "orange"
    },
    tag: {
      background: colors.greys[20],
      color: colors.greys[80],
      selected: {
        background: gradients.orange,
        color: colors.white
      }
    }
  },
  button: {
    hover: {
      background: colors.white
    }
  },
  subMenuLine: colors.greys[40],
  tooltip: {
    background: colors.greys[70]
  }
};
export { accountGroupNavTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3VudEdyb3VwLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9
